module.exports = __webpack_public_path__ + "static/media/bulk_manual_cons_upload.9f63ed11.csv";